// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";

const getSalesRepByLocationUri = "api/sainc/salespersonByLocation";

export interface GetSalesPersonByLocationApiParameter extends ApiParameter {
    country: string;
    state: string;
}

export interface GetSalesPersonByLocationApiResponse {
    email: string;
    imagePath: string;
    name: string;
    phone1: string;
    phone2: string;
    email2: string;
    properties: Record<string, unknown>;
    uri: string | null;
}

export async function getSalesPersonByLocation(
    parameter: GetSalesPersonByLocationApiParameter,
): Promise<ServiceResult<GetSalesPersonByLocationApiResponse>> {
    try {
        const result = await get<GetSalesPersonByLocationApiResponse>(getSalesRepByLocationUri, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
